<script setup>
  import { ref, computed, useSlots } from 'vue';
  import Icon from '@/components/icons/Icon.vue';

  defineEmits(['input:change']);

  const props = defineProps({
    disabled: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    dragMode: {
      type: String,
      default: 'use'
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'checkbox'
    },
    size: {
      type: String,
      required: false
    },
    showSubsettings: {
      type: Boolean,
      default: true
    },
  });

  const slots = useSlots();

  const collapsed = ref(props.collapsed);

  const hasSubsettings = computed(() => props.showSubsettings && !!slots.subsettings);
  const hasIcon = computed(() => !!slots.icon);

  const showDragGrip = computed(() => props.draggable && props.dragMode === 'arrange');
</script>

<template>
  <li
    class="jwx-settings__item"
    :data-drag-disabled="props.dragMode === 'use'"
  >
    <Icon v-if="showDragGrip" name="grip-dots" class="jwx-settings__drag-icon" />
    <div 
      class="jwx-settings__primary"
      :data-collapsible="props.collapsible"
    >
      <slot v-if="hasIcon" name="icon"></slot>
      <slot name="default"></slot>
      <button
        v-if="props.collapsible"
        @click="collapsed = !collapsed"
        type="button"
        class="jwx-settings__disclosure-button"
        :aria-expanded="!collapsed"
      >
        <Icon name="chevron-down" />
      </button>
    </div>
    <div
      v-if="hasSubsettings && (!collapsed || !props.collapsible)"
      class="jwx-settings__subsettings"
    >
      <ul class="jwx-settings__subsettings-list" >
        <slot name="subsettings"></slot>
      </ul>
    </div>
  </li>
</template>